import type { AlignmentGuide } from "./alignmentGuides";

// Колко линията излиза извън подравнените елементи (пиксели).
const OVERHANG_PX = 14;

/**
 * Помощните линии при местене: тънки (1px), в кехлибарения цвят с половин
 * прозрачност — подсказват, без да крещят. Позицията е от логическите
 * координати × мащаба (известна чак по време на изпълнение → inline `style`).
 */
const AlignmentGuideLines = ({
  guides,
  scale,
  origin,
}: {
  guides: AlignmentGuide[];
  scale: number;
  origin: { left: number; top: number };
}) => (
  <>
    {guides.map((guide) => {
      const isVertical = guide.orientation === "vertical";
      const across = (isVertical ? origin.left : origin.top) + guide.position * scale;
      const from = (isVertical ? origin.top : origin.left) + guide.start * scale - OVERHANG_PX;
      const length = (guide.end - guide.start) * scale + OVERHANG_PX * 2;
      return (
        <span
          key={`${guide.orientation}-${guide.position}`}
          className={`pointer-events-none absolute z-20 bg-brand/50 ${isVertical ? "w-px" : "h-px"}`}
          style={
            isVertical
              ? { left: Math.round(across), top: from, height: length }
              : { top: Math.round(across), left: from, width: length }
          }
        />
      );
    })}
  </>
);

export default AlignmentGuideLines;
